import langJa from "./ja.json";
const message = {
  ja: langJa,
  en: {},
};
export default message;
